
            import {IPropertyEditorProps, IPropertyEditorState} from '@mintdata/mint-kit/api/properties/PropertyEditor';
            import * as React from 'react';
            
            export class LayoutModelEditor<P extends IPropertyEditorProps<T>, S extends IPropertyEditorState, T> extends React.Component<P, S>
            {}
        